var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signError-wrap"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("您无权限查看此文件")]),_c('div',{staticClass:"img-wrap"},[_c('img',{attrs:{"src":require("@/assets/imgs/authenticationError.png"),"alt":""}})])])])
}]

export { render, staticRenderFns }